<template>
  <div class="rhg-spa-cards-auto-grid">
    <div class="rhg-slider-title-auto-grid">
      <typography v-if="title && cards.length < 4" tag="h2" size="2xl"> {{ title }} </typography>
    </div>
    <slider-card
      v-if="cards.length > 3"
      :title="title"
      :slides="cards"
      class="rhg-spa-cards-slider"
    ></slider-card>
    <div v-else class="rhg-row-grid-system">
      <component
        v-for="(card, indx) in cards"
        :key="indx"
        :is="card.type"
        v-bind="card.props"
        :numberOfCards="cards.length"
      />
    </div>
  </div>
</template>

<script>
import CardSpa from '../../Molecules/Molecules-cards/card-spa/CardSpa.vue'
import SliderCard from '../../Molecules/Molecules-cards/slider-card/SliderCard.vue'
import Typography from '../../Atoms/typography/Typography.vue'

export default {
  name: 'SpaCardsAutoGrid',

  props: {
    title: {
      type: String,
      required: true
    },
    cardsData: {
      type: Array,
      required: true
    }
  },

  components: {
    SliderCard,
    Typography
  },
  computed: {
    cards () {
      return this.cardsData.map(props => ({ type: CardSpa, props: { ...props, row: this.cardsData.length < 4 } }))
    }
  }
}
</script>
<style lang="scss">
.rhg-spa-cards-auto-grid {
  margin: 0.5rem 0;
  padding: 48px 0;
    @media (max-width:992px){
      padding: 36px 0;
    }
  .rhg-slider-title-auto-grid {
    padding-bottom: 24px;
  }
  .rhg-spa-cards-slider {
    .rhg-spa-card-body {
      justify-content: flex-start;
    }
    .rhg-spa-image {
      display: block;
    }
    .rhg-spa-image-wrapper {
      width: 100%;
    }
    .rhg-spa-card .rhg-card-body {
      padding: 24px;
    }
    .rhg-text-list-with-title {
      padding-top: 12px;
    }
    .rhg-text-list-with-title-one {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 12px;

    }
  }
}
.rhg-row-grid-system {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.slide {
  .rhg-spa-card-picture {
    height: 150px;
    min-height: auto;
  }

  .rhg-spa-card-four-hours {
    border-top: unset;
    padding-top: 0;
  }
}
</style>
